import React from 'react';

import { defineMessages } from '@sm/intl';

import ListingsBasePage from './ListingsBasePage';

const COPY = defineMessages({
  PAGE_TITLE: {
    id: 'Listings.RecentlyAdded.Title',
    defaultMessage: 'Recently Added',
    description: '[Type: Header][Vis.: high] - The title of the page for the more recently added apps.',
  },
});

const RecentlyAdded = () => {
  return (
    <ListingsBasePage
      pageId="App Directory - Recently Added"
      filter="RECENTLY_ADDED"
      title={COPY.PAGE_TITLE.defaultMessage}
      pageTitle="SurveyMonkey Recently Added Apps &amp; Integrations"
      description="Integrate SurveyMonkey’s Most Recently Added apps and plug-ins to get more done"
    />
  );
};

export default RecentlyAdded;
